import gsap from 'gsap';

function initAnim() {
  const heroEl = document.querySelector('#aboutHero');
  const heroSVG = document.querySelector('#heroSVG');
  const earth = heroSVG.querySelector('#world-about')
  const make = heroSVG.querySelector('#make')
  const people = heroSVG.querySelector('#people')
  const demand = heroSVG.querySelector('#demand')
  const better = heroSVG.querySelector('#better')
  const megaphone = heroSVG.querySelector('#megaphone')
  const sound1 = heroSVG.querySelector('#rect1')
  const sound2 = heroSVG.querySelector('#rect2')
  const sound3 = heroSVG.querySelector('#rect3')

  gsap.ticker.fps(30)
  const tl = gsap.timeline({onStart: () => {
    heroEl.classList.remove('about-hero-is-loading');
  }});

  tl.set([make, people, demand, better], {yPercent: -2000, xPercent: -10});
  tl.set(megaphone, {yPercent: -2000});

  tl
  .fromTo(
    [demand, better],
    { yPercent: -2000, xPercent: -10, opacity: 0 },
    { duration: 0.5, stagger: 0.1, opacity: 1, yPercent: -2, ease: 'power2.in' },
  )
  .set(tl, {timeScale: 0.4})
  .to([demand, better], {
    duration: 0.1,
    stagger: 0.01,
    yPercent: 0,
    xPercent: 0,
    ease: 'power1.in',
  })
  .fromTo(
    [make, people],
    { yPercent: -2000, xPercent: -10 },
    { duration: 1, yPercent: -1, ease: 'power2.in' },
    '>-1',
  )
  .to([make, people], {
    duration: 0.1,
    stagger: 0.01,
    yPercent: 0,
    xPercent: 0,
    ease: 'power1.in',
  })
  .from(earth, {
    rotation: "180deg",
    transformOrigin: "50% 50%",
    duration: 0.5,
    xPercent: -100,
    ease: 'power2.in'
  }, '>-0.5')
  .to(earth, {
    duration: 0.1,
    xPercent: 1,
    yoyo: true,
    repeat: 1,
    transformOrigin: '50% 100%',
    ease: 'power2.out',
  })
  .to(demand, {
    duration: 0.1,
    rotate: -0.25,
    yPercent: 0.25,
    xPercent: 0.5,
    yoyo: true,
    repeat: 1,
    transformOrigin: '50% 100%',
  },'>-0.2')
  .to(make, {
    duration: 0.1,
    rotate: 0.25,
    yPercent: -0.25,
    xPercent: 1,
    yoyo: true,
    repeat: 1,
    transformOrigin: '50% 100%',
  },'>-0.1')
  .fromTo(megaphone, {yPercent: -2000}, {
    duration: 1,
    yPercent: 0,
    transformOrigin: "50% 100%",
    ease: 'power2.in'
  }, '>-1.1')
  .to(megaphone, {
    duration: 0.1,
    rotate: 5,
    yoyo: true,
    repeat: 1,
    transformOrigin: '50% 100%',
  },'>-0.1')
  .from([sound1, sound2, sound3], {
    duration: 0.1,
    scaleX: 0,
    transformOrigin: '100% 50%',
    repeat: 1,
  },'>-0.1');
}

function init() {
  const about = document.querySelector('#about');
  if (!about) {
    return;
  }

  initAnim();
}

init();
